import { isTabFeatureEnabled } from './tabFeatureSwitch';

/**
 * 与 TabKeepAliveShell 一致：是否启用路由级 KeepAlive（instance 主栈）。
 */
export function isTabRouteKeepAliveEnabled(): boolean {
  const envEnabled =
    process.env.REACT_APP_TAB_KEEPALIVE === '1' ||
    process.env.REACT_APP_TAB_KEEPALIVE === 'true';
  return isTabFeatureEnabled() && envEnabled;
}
